import { createTargetedSaveRequest, getCombatantSaveModifier } from './combatSavingThrows';
import { isProne } from './conditions';

export const qualifiesForTopple = ({ attack, outcome, targetId, combatState } = {}) =>
  Boolean(attack?.hasWeaponMastery && String(attack?.mastery?.key || attack?.mastery?.id || attack?.mastery?.label || attack?.weapon?.mastery || '').toLowerCase() === 'topple' &&
    ['hit', 'critical-hit'].includes(outcome) && !isProne(combatState, targetId));

export const getToppleSaveDC = (attack) => {
  if (!Number.isFinite(attack?.abilityModifier) || !Number.isFinite(attack?.proficiencyBonus)) throw new Error('Topple requires resolved attack math.');
  return 8 + attack.proficiencyBonus + attack.abilityModifier;
};

export const createToppleDecision = (resolutionId, dc) => ({
  id: `${resolutionId}:weapon-mastery:topple`, featureId: 'weapon-mastery:topple', resolutionId,
  label: 'Weapon Mastery: Topple', prompt: 'Force this creature to make a Constitution saving throw?', detail: `CON Save DC ${dc}`,
  choices: [{ id: 'apply', label: 'Topple' }, { id: 'skip', label: 'Skip' }],
});

export const createToppleSaveRequest = ({ resolutionId, attackerId, targetId, attack, target }) => createTargetedSaveRequest({
  requestId: `${resolutionId}:save`, replayIdentity: resolutionId, sourceCombatantId: attackerId, targetCombatantId: targetId,
  ability: 'constitution', dc: getToppleSaveDC(attack), targetSaveModifier: getCombatantSaveModifier(target, 'constitution'),
});
